import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'

export const useStatCardSharedStyles = makeStyles((theme: Theme) => ({
  statCardBackground: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 0,
    '& svg': {
      display: 'block',
      width: '100%',
      height: '100%'
    },

    '@media (min-width: 960px) and (max-width: 1200px)': {
      '& svg .stat-card-icon': {
        transform: 'translate(clamp(15px, 1.5vw, 18px), clamp(20px, 2vw, 24px)) scale(0.8, 0.8) !important'
      },
      '& svg .stat-card-icon[data-scale-x="1.3396"]': {
        transform: 'translate(clamp(15px, 1.5vw, 18px), clamp(20px, 2vw, 24px)) scale(1.1, 0.9) !important'
      },
      '& svg .stat-card-icon[data-scale-x="1.0416"]': {
        transform: 'translate(clamp(15px, 1.5vw, 18px), clamp(20px, 2vw, 24px)) scale(0.85, 0.8) !important'
      },
      '& svg .stat-card-icon[data-scale-x="1.1253"]': {
        transform: 'translate(clamp(15px, 1.5vw, 18px), clamp(20px, 2vw, 24px)) scale(0.9, 0.85) !important'
      }
    },
    '@media (min-width: 1200px) and (max-width: 1440px)': {
      '& svg .stat-card-icon': {
        transform: 'translate(clamp(18px, 1.5vw, 21px), clamp(24px, 2vw, 28px)) scale(0.9, 0.9) !important'
      },
      '& svg .stat-card-icon[data-scale-x="1.3396"]': {
        transform: 'translate(clamp(18px, 1.5vw, 21px), clamp(24px, 2vw, 28px)) scale(1.2, 1.0) !important'
      },
      '& svg .stat-card-icon[data-scale-x="1.0416"]': {
        transform: 'translate(clamp(18px, 1.5vw, 21px), clamp(24px, 2vw, 28px)) scale(0.95, 0.9) !important'
      },
      '& svg .stat-card-icon[data-scale-x="1.1253"]': {
        transform: 'translate(clamp(18px, 1.5vw, 21px), clamp(24px, 2vw, 28px)) scale(1.0, 0.95) !important'
      }
    },
    '@media (min-width: 1440px)': {
      '& svg .stat-card-icon': {
        transform: 'translate(21px, 28px) scale(0.9704, 0.9667) !important'
      },
      '& svg .stat-card-icon[data-scale-x="1.3396"]': {
        transform: 'translate(21px, 28px) scale(1.3396, 1.0876) !important'
      },
      '& svg .stat-card-icon[data-scale-x="1.0416"]': {
        transform: 'translate(21px, 28px) scale(1.0416, 0.9667) !important'
      },
      '& svg .stat-card-icon[data-scale-x="1.1253"]': {
        transform: 'translate(21px, 28px) scale(1.1253, 1.0441) !important'
      }
    },

    '@media (max-width: 599px)': {
      '& svg .stat-card-icon': {
        transform: 'translate(21px, 28px) scale(0.9704, 0.9667) !important'
      },

      '& svg .stat-card-icon[data-scale-x="1.3396"]': {
        transform: 'translate(21px, 28px) scale(1.3396, 1.0876) !important'
      },

      '& svg .stat-card-icon[data-scale-x="1.0416"]': {
        transform: 'translate(21px, 28px) scale(1.0416, 0.9667) !important'
      },

      '& svg .stat-card-icon[data-scale-x="1.1253"]': {
        transform: 'translate(21px, 28px) scale(1.1253, 1.0441) !important'
      }
    }
  },
  statCardContent: {
    position: 'relative',
    zIndex: 1,
    padding: '16.0267px',
    paddingTop: '40.0267px',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',

    '@media (min-width: 960px)': {
      padding: 'clamp(12px, 1.1vw, 16.0267px)',
      paddingTop: 'clamp(28px, 2.8vw, 40.0267px)'
    },

    '@media (max-width: 599px)': {
      padding: '12px',
      paddingTop: '28px',
      paddingBottom: '8px'
    }
  },
  statValueWrapper: {
    width: '202.16px',
    height: '80.834px',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(0.5),
    marginTop: '25px',

    '@media (min-width: 960px)': {
      width: 'auto',
      height: 'auto',
      maxWidth: '100%'
    },

    '@media (max-width: 767px)': {
      width: 'auto',
      height: 'auto',
      marginTop: '15px',
      marginBottom: theme.spacing(0.25)
    },

    '@media (max-width: 599px)': {
      width: 'auto',
      height: 'auto',
      marginTop: '8px',
      marginBottom: theme.spacing(0.25)
    }
  },
  statValue: {
    fontFamily: '"Euclid Circular A", sans-serif',
    fontSize: '69.902px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '170%',
    letterSpacing: '-3.495px',
    color: '#FFF',
    width: '100%',
    paddingBottom: '-30px',

    '@media (min-width: 960px)': {
      fontSize: 'clamp(45px, 4.5vw, 69.902px)',
      letterSpacing: 'clamp(-2px, -0.2vw, -3.495px)',
      lineHeight: 'clamp(140%, 17vw, 170%)'
    },

    '@media (max-width: 767px)': {
      fontSize: '45px',
      lineHeight: '140%',
      letterSpacing: '-2px'
    },

    '@media (max-width: 599px)': {
      fontSize: '38px',
      lineHeight: '130%',
      letterSpacing: '-1.5px'
    }
  },
  statLabel: {
    width: '188.12px',
    fontFamily: '"Euclid Circular A", sans-serif',
    fontSize: '19.401px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '100%',
    color: '#FFF',
    letterSpacing: '0em',

    '@media (min-width: 960px)': {
      width: 'auto',
      maxWidth: '100%',
      fontSize: 'clamp(14px, 1.2vw, 19.401px)',
      lineHeight: 'clamp(115%, 12vw, 120%)'
    },

    '@media (max-width: 767px)': {
      width: 'auto',
      fontSize: '14px',
      lineHeight: '120%'
    },

    '@media (max-width: 599px)': {
      width: 'auto',
      fontSize: '12px',
      lineHeight: '115%',
      maxWidth: '100%',
      overflow: 'visible'
    }
  }
}))
